import React from 'react';
import placeholder from '../assets/placeholder.png';
import { useRecordContext } from "react-admin";

const CustomImageField = ({ source, label, fileField }) =>
{
  const record = useRecordContext();
  if (record && record[source])
    return (
      <a
        href={record[source]}
        target="_blank"
        rel="noopener noreferrer"
        onClick={ (e) => { e.stopPropagation() }}>
        <img src={"data:image/jpeg;base64," + record[source]} alt="Logo" width="50" />
      </a>
    );
  else
    return (<img src={placeholder} alt="Logo" width="50" />);
};

export default CustomImageField;
